import styled from '@emotion/styled'

import { SUI, Dropdown } from 'shared/ui'
import { emptyArr, getLength } from 'util/arrays'
import { propFunc } from 'util/functions'

import RecipientItem from './RecipientItem'

const buildOptions = (recipients, onClick) => {
  return recipients.filter(e => !!e).map(r => ({
    key: r.id,
    content: <RecipientItem recipient={r} />,
    onClick: propFunc(onClick, r.id),
    value: r.id,
  }))
}

const RecipientDropdown = ({
  className,
  disabled,
  isSearching,
  lastFilteredSize,
  onClick,
  onClose,
  onBlur,
  recipients,
  sui,
  trigger,
  upward,
}) => {
  return (
    <SUI>
      <Dropdown
        className={className}
        icon={null}
        onBlur={onBlur}
        onClose={onClose}
        open={
          sui
            ? !disabled
            : !disabled &&
              (getLength(recipients) > 0 ||
                (isSearching && lastFilteredSize > 0))
        }
        openOnFocus={false}
        options={!isSearching ? buildOptions(recipients, onClick) : emptyArr}
        scrolling
        trigger={trigger}
        upward={upward}
        tabIndex={sui ? -1 : 0}
      />
    </SUI>
  )
}

export default styled(RecipientDropdown)`
  &&& {
    width: 100%;
    align-items: center;
    color: ${props => props.theme.color.primary.brand};
    cursor: pointer;
    display: inline-flex;
    margin-left: ${props => (props.sui ? '' : '4px')};

    .dropdown {
      &.icon {
        /* SUI override for a bigger caret thats closer to icon */
        font-size: ${props => props.theme.fontSize.small} !important;
        margin-left: ${props => props.theme.spacing['4']} !important;
      }
    }

    & > .menu.menu.menu {
      max-width: 350px;
      min-width: 0 !important;
    }
  }
`
